var render = function render(){var _vm=this,_c=_vm._self._c;return _c(`header-${_vm.type}`,{tag:"component",attrs:{"menu":_vm.menu,"country":_vm.country,"lang":_vm.lang,"logo":_vm.logo,"usps":_vm.usps,"legal-link":_vm.helpLink,"secondary-links":_vm.secondaryLinks,"hide-usps":_vm.hideUsps,"redirect-ccl-to-home":_vm.redirectCclToHome,"show-breadcrumbs":_vm.showBreadcrumbs}})
}
var staticRenderFns = []

export { render, staticRenderFns }